import React, { useEffect, useState, useRef } from "react";
import DateInput from "./DateInput";
import { Input } from "./ui/input";
import { cn } from "@/lib/utils";

// Wire format: "YYYY-MM-DDTHH:mm" (matches native datetime-local). Renders a
// DateInput + separate HH:mm text input so the date part always shows
// DD/MM/YYYY regardless of browser locale.
function split(v) {
    if (!v) return { d: "", t: "" };
    const [d, tRaw = ""] = v.split("T");
    const t = tRaw.slice(0, 5); // HH:mm
    return { d: d || "", t };
}

function join(d, t) {
    if (!d) return "";
    return `${d}T${t || "00:00"}`;
}

export default function DateTimeInput({
    value,
    onChange,
    className,
    disabled,
    required,
    "data-testid": dataTestId,
    ...rest
}) {
    const [{ d, t }, setDT] = useState(split(value));
    const last = useRef(value || "");

    useEffect(() => {
        if ((value || "") !== last.current) {
            setDT(split(value));
        }
    }, [value]);

    const emit = (newD, newT) => {
        const combined = newD ? join(newD, newT || "00:00") : "";
        last.current = combined;
        onChange?.(combined);
    };

    return (
        <div className={cn("inline-flex items-center gap-2", className)}>
            <DateInput
                value={d}
                onChange={(nd) => { setDT((s) => ({ ...s, d: nd })); emit(nd, t); }}
                disabled={disabled}
                required={required}
                data-testid={dataTestId ? `${dataTestId}-date` : undefined}
                {...rest}
            />
            <Input
                type="time"
                value={t}
                onChange={(e) => {
                    const nt = e.target.value;
                    setDT((s) => ({ ...s, t: nt }));
                    emit(d, nt);
                }}
                disabled={disabled}
                required={required}
                className="w-28"
                data-testid={dataTestId ? `${dataTestId}-time` : undefined}
            />
        </div>
    );
}
